var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"flex h-[38px] items-center justify-between py-3 pl-4"},[_c('h2',{staticClass:"text-sm font-medium leading-none text-vanilla-300",attrs:{"id":_vm.headingId}},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }